import { render, staticRenderFns } from "./ModalParty.vue?vue&type=template&id=58546da6&"
import script from "./ModalParty.vue?vue&type=script&lang=js&"
export * from "./ModalParty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports